import React from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "shared/context/auth-context";
import { canUseStartExperience, getStartDeniedRedirect } from "features/start/start-audience";
import { isInternationalTheme } from "config/ConfigUtils";
import StartExperience from "./StartExperience";

const StartRoute = () => {
  const auth = React.useContext(AuthContext);
  const allowed = canUseStartExperience({
    isLoggedIn: auth.isLoggedIn,
    permissions: auth.permissions,
    role: auth.client?.role,
  });

  if (!allowed) {
    const fallback = auth.isLoggedIn
      ? getStartDeniedRedirect({
          permissions: auth.permissions,
          role: auth.client?.role,
          isInternational: isInternationalTheme(),
        })
      : "/login";
    return <Navigate to={fallback} replace />;
  }

  return <StartExperience />;
};

export default StartRoute;
